export default __webpack_public_path__ + "assets/images/fc1e92ff45f67fb3d3dcac523e6ec8f0.jpg";